import clsx from 'clsx'
import {Fragment} from 'react'
import {Link} from 'react-router'

import {useLayout} from '../../../core'
import {usePageData} from '../../../core/PageData'
import {useBreadcrumbTrail} from './useBreadcrumbTrail'

/**
 * One-line page heading: muted ancestor crumbs (from the sidebar tree, see
 * useBreadcrumbTrail) followed by the page title as the last crumb.
 * "Finance › Vendors › **Add Vendor**".
 */
const PageTitle = () => {
  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config, classes} = useLayout()
  const {ancestors, title} = useBreadcrumbTrail({
    pageTitle,
    manualBreadcrumbs: pageBreadcrumbs,
  })

  const showTitle = !!config.app?.pageTitle?.display && !!title
  const showCrumbs = showTitle && !!config.app?.pageTitle?.breadCrumb && ancestors.length > 0
  const showDescription = showTitle && !!config.app?.pageTitle?.description && !!pageDescription

  if (!showTitle) {
    return null
  }

  return (
    <div
      id='kt_page_title'
      className={clsx(
        'page-title d-flex flex-wrap align-items-center me-3',
        classes.pageTitle.join(' '),
        config.app?.pageTitle?.class
      )}
    >
      <nav aria-label='breadcrumb'>
        <ol className='breadcrumb breadcrumb-separatorless fw-semibold my-0 align-items-center'>
          {showCrumbs &&
            ancestors.map((crumb, index) => (
              <Fragment key={`${crumb.path ?? ''}${index}`}>
                <li className='breadcrumb-item text-muted fs-6'>
                  {crumb.path ? (
                    <Link className='text-muted text-hover-primary' to={crumb.path}>
                      {crumb.title}
                    </Link>
                  ) : (
                    crumb.title
                  )}
                </li>
                <li className='breadcrumb-item px-1 text-gray-400 fs-6' aria-hidden='true'>
                  ›
                </li>
              </Fragment>
            ))}
          <li className='breadcrumb-item' aria-current='page'>
            <h1 className='page-heading text-gray-900 fw-bold fs-3 my-0'>{title}</h1>
          </li>
        </ol>
      </nav>
      {showDescription && (
        <span className='page-desc text-muted fs-7 fw-semibold ms-3'>{pageDescription}</span>
      )}
    </div>
  )
}

export {PageTitle}
